import { styled } from '@linaria/react';
import { StyledLandingSection } from './LandingSection';
export const StyledLandingScreenshotFigure = /*#__PURE__*/styled("div")({
  name: "StyledLandingScreenshotFigure",
  class: "s1vhebo9"
});
export const LandingScreenshot = () => {
  return <StyledLandingSection className="screenshot">
			<div className="content">
				<StyledLandingScreenshotFigure className="screenshot-img">
					<img src="/img/1024x576.svg" alt="placeholder" />
				</StyledLandingScreenshotFigure>
			</div>
		</StyledLandingSection>;
};

require("./LandingScreenshot.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingScreenshot.tsx");